import { UserState } from '../../../shared/UserState.ts';
import { UIAjaxWrapper } from './network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from './network/UIAPIEndpoints.ts';
import { ArrayUtils, createDeferredPromise, delay } from '@colonist/utils';
import { StorageWrapper } from './StorageWrapper.ts';
export class ClientUserState {
    static isStale() {
        return this._stale;
    }
    static get userState() {
        return this._userState;
    }
    static get abTests() {
        var _this__abTests;
        return (_this__abTests = this._abTests) !== null && _this__abTests !== void 0 ? _this__abTests : {};
    }
    static get haveAbTestsLoaded() {
        return this._abTests != undefined;
    }
    static hasUser() {
        return this._userState !== undefined;
    }
    static async _fetchUserState() {
        const userState = await this.fetchUserStateFromServer();
        if (userState == false) return false;
        this._stale = false;
        this.update(userState);
        this.waitUntilFresh.resolve();
        return true;
    }
    static async fetchUserStateFromServer() {
        const getResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserState(), undefined);
        this._abTests = undefined;
        if (getResponse == undefined) return false;
        const userStateGetResponse = getResponse.json;
        this._abTests = userStateGetResponse.abTests;
        UIAjaxWrapper.csrfToken = userStateGetResponse.csrfToken;
        return userStateGetResponse.userState;
    }
    static async createUser() {
        if (this.createUserPromise != undefined) return this.createUserPromise;
        this.createUserPromise = createDeferredPromise();
        try {
            const postResponse = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiUserStateCreate(), undefined, undefined);
            const userStatePostResponse = postResponse === null || postResponse === void 0 ? void 0 : postResponse.json;
            if ((userStatePostResponse === null || userStatePostResponse === void 0 ? void 0 : userStatePostResponse.userState) == undefined) {
                this.createUserPromise.resolve(false);
                return this.createUserPromise;
            }
            this._abTests = userStatePostResponse === null || userStatePostResponse === void 0 ? void 0 : userStatePostResponse.abTests;
            this.createUserPromise.resolve(userStatePostResponse.userState);
            return this.createUserPromise;
        } finally{
            this.createUserPromise = undefined;
        }
    }
    static async requireUser() {
        if (this.userState != undefined) return;
        const userState = await this.createUser();
        if (userState == false) {
            throw new Error('Unable to create user') // TODO display
            ;
        }
        this.update(userState);
    }
    static async refresh() {
        await this._fetchUserState();
    }
    static update(userStateData) {
        const isUserStateExpired = (userStateData === null || userStateData === void 0 ? void 0 : userStateData.expiresAt) && new Date(userStateData.expiresAt) < new Date();
        if (isUserStateExpired == true) {
            userStateData = undefined;
        }
        if (userStateData != undefined) {
            StorageWrapper.setUserState(userStateData);
            this._userState = new UserState(userStateData);
        } else {
            StorageWrapper.clearUserState();
            this._userState = undefined;
        }
        for (const changeListener of this.changeListeners){
            changeListener(ClientUserState._userState);
        }
    }
    static registerChangeListener(callback) {
        this.changeListeners.push(callback);
        callback(this._userState);
        return ()=>{
            ArrayUtils.removeElementFromArray(this.changeListeners, callback);
        };
    }
    static async init() {
        if (this.loadInitialStateFromStorage()) {
            void this.initFetchLoop() // refresh user state in background
            ;
            return true;
        }
        return this.initFetchLoop();
    }
    static loadInitialStateFromStorage() {
        try {
            const cachedUserState = StorageWrapper.getUserState();
            if (cachedUserState == undefined) return false;
            this.update(cachedUserState);
            return true;
        } catch  {
            return false;
        }
    }
    static async initFetchLoop() {
        const maxFetchAttempts = 10;
        for(let i = 0; i < maxFetchAttempts; i++){
            const success = await this._fetchUserState();
            if (success) return true;
            await delay(100);
        }
        return false;
    }
}
ClientUserState.changeListeners = [];
ClientUserState._stale = true // loaded from client storage, not server
;
ClientUserState.waitUntilFresh = createDeferredPromise();
